import { Injectable } from '@angular/core';

/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Ryan Duffy
 */
@Injectable({
  providedIn: 'root',
})
export class BaseModel {
  constructor() {}
  /**
   *  gets the current object and returns it in JSON format
   *
   * @returns {Object}
   * @memberof BaseModel
   */
  toJson<type>(data: type): Object {
    // Pass the current object into the generic toJSON Logic
    return this.toJsonLogic(data, true);
  }
  /**
   *  takes and an input and converts it into the current object of this keyword context
   *
   * @param {*} input
   * @returns {this}
   * @memberof BaseModel
   */
  fromJson<T>(input: any, item: T): T {
    return this.fromJsonLogic<T>(input, item, true);
  }
  /**
   *  gets the current object and returns {Object} in a JSON format
   * this can convert either the current this context or any other object needed
   * key to the logic is that this method can call itself if there is any nested Objects
   *
   * @private
   * @param {*} input
   * @returns {Object}
   * @memberof BaseModel
   */
  private toJsonLogic(input: any, embedded?: boolean): Object {
    let jsonProperties: string[];
    let jsonProperty: string;
    const object = {};
    let index = 0;
    for (const property in input) {
      if (property !== 'constructor' && property.indexOf('Json') === -1) {
        jsonProperties = property.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g) || [property];
        for (let i = 0; i < jsonProperties.length; i++) {
          jsonProperties[i] = jsonProperties[i].toLocaleLowerCase();
        }
        jsonProperty = jsonProperties.join('_');
        if (input[property] instanceof Object && embedded) {
          if (!Array.isArray(input[property])) {
            object[jsonProperty] = this.toJsonLogic(input[property]);
          } else {
            object[jsonProperty] = [];
            for (const item of input[property]) {
              object[jsonProperty][index] = this.toJsonLogic(item);
              index++;
            }
          }
        } else {
          object[jsonProperty] = input[property];
        }
      }
    }
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }
  /**
   *  gets the JSON input and converts it into and instance of an Object or the current this context
   * key to the logic is that this method can call itself if there is any nested Objects so they will also be converted to an Object
   * and not Raw JSON
   *
   * @private
   * @param {*} input
   * @param {(Object | this)} object
   * @returns {(this | Object)}
   * @memberof BaseModel
   */
  private fromJsonLogic<Type = Object>(input: any, object: Type, embedded?: boolean): Type {
    let propertyNameDivider: string[];
    let propertyName: string;
    let index = 0;
    const fullReturnObject = object;
    for (const element in input) {
      if (element !== 'constructor' && element.indexOf('Json') === -1) {
        propertyNameDivider = element.split('_') || [element];
        if (propertyNameDivider.length > 1) {
          if (propertyNameDivider.length > 1) {
            for (let i = 1; i < propertyNameDivider.length; i++) {
              propertyNameDivider[i] =
                propertyNameDivider[i].substring(0, 1).toUpperCase() +
                propertyNameDivider[i].substring(1, propertyNameDivider[i].length);
            }
          }
        }
        propertyName = propertyNameDivider.join('');
        if (input[element] instanceof Object && embedded) {
          if (!Array.isArray(input[element])) {
            fullReturnObject[propertyName] = this.fromJsonLogic(input[element], {});
          } else {
            fullReturnObject[propertyName] = [];
            for (const item of input[element]) {
              fullReturnObject[propertyName][index] = this.fromJsonLogic(item, {});
              index++;
            }
          }
        } else {
          fullReturnObject[propertyName] = input[element];
        }
      }
    }
    return fullReturnObject;
  }
}
